import deliveryOptionsController from './deliveryOptionsController'

export default deliveryOptionsController



// WEBPACK FOOTER //
// ../src/controllers/deliveryOptionsController/index.js